"use client";

import React, { useCallback } from "react";
import { 
  Box, 
  Flex,
  Grid, 
  GridItem, 
  Heading, 
  Text, 
  HStack,
  VStack,
  Container
} from "@chakra-ui/react";
import MetricsCard from "./MetricsCard";
import ProgressBar from "./ProgressBar";
import { formatDate, formatDuration } from "../../utils/timeUtils";

interface MetricsCardProps {
  details: {
    totalMeetings: number;
    activeClientCount: number;
    avgSessionDuration: number | string;
    lastActive: string;
  };
}

interface DateFormatterProps {
  dateString: string;
}

const MetricsOverview: React.FC<MetricsCardProps> = ({ details }) => {
  return (
    <Flex gap={4} flexWrap="wrap" w="full">
      <ActivityOverview details={details} />
      {/* <PerformanceCard /> */}
      <TimeMetrics details={details} />
    </Flex>
  );
};

const ActivityOverview: React.FC<MetricsCardProps> = ({ details }) => {
  const { totalMeetings, activeClientCount } = details;
  return (
    <MetricsCard 
      title="Activity Overview"
      flex="1"
      minW="300px"
      maxW="372px"
    >
      <Grid templateColumns="repeat(2, 1fr)" gap={6} mt={4}>
        <Box>
          <Text fontSize="sm" color="gray.500">Total Meetings</Text>
          <Text mt={2.5} fontSize="xl" color="gray.800" fontWeight="semibold">{totalMeetings}</Text>
        </Box>
        <Box>
          <Text fontSize="sm" color="gray.500">Active Clients</Text>
          <Text mt={2.5} fontSize="xl" color="gray.800" fontWeight="semibold">{activeClientCount}</Text>
        </Box>
      </Grid>
    </MetricsCard>
  );
};

const PerformanceCard: React.FC = () => {
  return (
    <MetricsCard 
      title="Performance"
      minW="300px"
      width={{ base: "100%", md: "372px" }}
    >
      <VStack align="stretch" spacing={2.5} mt={4}>
        <Flex justify="space-between" fontSize="sm" fontWeight="semibold">
          <Text color="gray.500">Positivity Score:</Text>
          <Text color="gray.800">45%</Text>
        </Flex>
        <ProgressBar 
          percentage={45} 
          color="blue.500" 
          height="8px"
        />
        <Flex justify="space-between" fontSize="sm" fontWeight="semibold" mt={2.5}>
          <Text color="gray.500">Pending Actions:</Text>
          <Text color="gray.800">03</Text>
        </Flex>
      </VStack>
    </MetricsCard>
  );
};

const TimeMetrics: React.FC<MetricsCardProps> = ({ details }) => {
  const { avgSessionDuration, lastActive } = details;
  return (
    <MetricsCard 
      title="Time Metrics"
      minW="300px"
      width={{ base: "100%", md: "372px" }}
    >
      <Grid templateColumns="repeat(2, 1fr)" gap={6} mt={4}>
        <Box>
          <Text fontSize="sm" color="gray.500" fontWeight="semibold">Avg Duration</Text>
          <Text mt={2.5} fontSize="xl" color="gray.800" fontWeight="semibold">{formatDuration(avgSessionDuration as number)}</Text>
        </Box>
        <Box>
          <Text fontSize="sm" color="gray.500" fontWeight="semibold">Last Activity</Text>
          <Text mt={2.5} fontSize="xl" color="gray.800" fontWeight="semibold">{formatDate(lastActive)}</Text>
        </Box>
      </Grid>
    </MetricsCard>
  );
};

export default MetricsOverview;